import {VehicleTypeEnum} from '@dms/api/vehicle';

export const isTrailerOrSemitrailer = (vehicleType: VehicleTypeEnum) =>
  vehicleType === 'VEHICLETYPE_SEMI_TRAILER' || vehicleType === 'VEHICLETYPE_TRAILER';
